import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { REST_API_URL } from "../../Utils/Global";

import ExportView from '../Helper/Grid/ExportView';

import Combobox from '../Helper/Combobox';

import { Link } from 'react-router-dom';

/**
* Class ActiviteClientList
* ActiviteClientList view component
**/
class RequeteDomaineRGPDList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      requete: {}
    };
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {




    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Requêtes</h2>
        <Combobox url={REST_API_URL + "requetesDomaineRGPD/"} optionValueKey="idRequete" optionLabelKey="nom"
          onChange={this.onRequeteSelect.bind(this)} placeholder="Choisir une requête" />
            <h2></h2>
        <ExportView parent={this}  />
      </div>
		);
	}

  /**
  * onObjectifSelect
  * Handle Objectif selection
  **/
  onRequeteSelect(requete) {
    this.setState({
      requete: requete
    });
  }


}
export default RequeteDomaineRGPDList;



// WEBPACK FOOTER //
// ./src/views/Search/RequeteDomaineRGPDList.js